import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

import {AuthGuard} from './guards/auth.guard';
import {FeatureGuard} from './guards/feature.guard';
import {ActsComponent} from 'app/views/acts/acts.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {title: 'Home'},
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ActsComponent,
        data: {title: 'Acts'},
        canActivate: [FeatureGuard]
      },
      {
        path: 'users',
        loadChildren: './views/users/users.module#UsersModule'
      },
      {
        path: 'roles',
        data: {title: 'Roles'},
        loadChildren: './views/roles/roles.module#RolesModule'
      }
    ]
  },
  {
    path: '',
    component: SimpleLayoutComponent,
    data: {
      title: 'Pages'
    },
    children: [
      {
        path: '',
        loadChildren: './views/pages/pages.module#PagesModule',
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/app.routing.ts